import { Link } from "react-router-dom";
import { Share2 } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import type { FactCheck } from "@/lib/mock-data";
import { VerdictBadge } from "./Badges";

function fmt(iso: string, locale: string) {
  return new Date(iso).toLocaleDateString(locale === "fr" ? "fr-FR" : "en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function FactCheckCard({ fc }: { fc: FactCheck }) {
  const { locale, t } = useI18n();
  const claim = fc.claim[locale] ?? fc.claim.fr ?? "";
  const exp = fc.shortExplanation[locale] ?? fc.shortExplanation.fr ?? "";

  return (
    <article className="flex flex-col gap-3 rounded-md border border-border bg-card p-5 shadow-card hover:shadow-elevated transition-shadow">
      <div className="flex items-center justify-between gap-3">
        <VerdictBadge verdict={fc.verdict} size="md" />
        <span className="text-[11px] text-muted-foreground">{fmt(fc.date, locale)}</span>
      </div>
      {/* ✅ slug réel */}
      <Link to={`/factcheck/${fc.slug}`} className="group">
        <h3 className="text-base font-semibold leading-snug text-foreground group-hover:text-verified transition-colors">
          « {claim} »
        </h3>
      </Link>
      <p className="text-sm text-muted-foreground line-clamp-3">{exp}</p>
      <div className="mt-1 flex items-center justify-between text-xs">
        {/* ✅ slug réel */}
        <Link to={`/factcheck/${fc.slug}`} className="font-medium text-foreground hover:text-verified">
          {t("cta.readMore")} →
        </Link>
        {/* <button
          className="inline-flex items-center gap-1.5 text-muted-foreground hover:text-foreground"
          aria-label={t("cta.share")}
        >
          <Share2 className="h-3.5 w-3.5" /> {t("cta.share")}
        </button> */}
      </div>
    </article>
  );
}